import {RefObject, useLayoutEffect} from "react";

import {findScrollParent} from "../utils/find_scroll_parent";

const PIN_DURATION_MS = 220;

/** While active, scrolls the nearest scrolling ancestor to the top and keeps it there for a short moment. */
export const usePinScrollParentToTop = (elementRef: RefObject<HTMLElement | null>, isActive: boolean) => {
    useLayoutEffect(() => {
        if (!isActive || !elementRef.current) return;

        const scroller = findScrollParent(elementRef.current);

        if (!scroller) return;

        const previousOverflowAnchor = scroller.style.overflowAnchor;

        scroller.style.overflowAnchor = "none";
        scroller.scrollTop = 0;

        const pinScroll = () => {
            if (scroller.scrollTop !== 0) scroller.scrollTop = 0;
        };

        scroller.addEventListener("scroll", pinScroll);
        const timeoutId = window.setTimeout(() => scroller.removeEventListener("scroll", pinScroll), PIN_DURATION_MS);

        return () => {
            window.clearTimeout(timeoutId);
            scroller.removeEventListener("scroll", pinScroll);
            scroller.style.overflowAnchor = previousOverflowAnchor;
        };
    }, [elementRef, isActive]);
};
import {RefObject, useLayoutEffect} from "react";

import {findScrollParent} from "../utils/find_scroll_parent";

const PIN_DURATION_MS = 220;

/** While active, scrolls the nearest scrolling ancestor to the top and keeps it there for a short moment. */
export const usePinScrollParentToTop = (elementRef: RefObject<HTMLElement | null>, isActive: boolean) => {
    useLayoutEffect(() => {
        if (!isActive || !elementRef.current) return;

        const scroller = findScrollParent(elementRef.current);

        if (!scroller) return;

        const previousOverflowAnchor = scroller.style.overflowAnchor;

        scroller.style.overflowAnchor = "none";
        scroller.scrollTop = 0;

        const pinScroll = () => {
            if (scroller.scrollTop !== 0) scroller.scrollTop = 0;
        };

        scroller.addEventListener("scroll", pinScroll);
        const timeoutId = window.setTimeout(() => scroller.removeEventListener("scroll", pinScroll), PIN_DURATION_MS);

        return () => {
            window.clearTimeout(timeoutId);
            scroller.removeEventListener("scroll", pinScroll);
            scroller.style.overflowAnchor = previousOverflowAnchor;
        };
    }, [elementRef, isActive]);
};
